// libs
import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

// components
import Header from "../../components/Header";
import Navigator from "../../components/Navigator";
import UpdatesModal from "../../components/UpdatesModal";

// custom hooks
import useToken from "../../hooks/useToken";
import useUserData from "../../hooks/useUserData";
import useVersion from "../../hooks/useVersion";

// constatns
import ROUTES from "../../constants/routes";

// styles
import classes from "./styles.module.css";

export default function HomePage() {
  const { userData, fetchUserData } = useUserData();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAppUpdated, updateVersion } = useVersion();

  const [token] = useToken();

  useEffect(() => {
    if (token === null) {
      navigate(ROUTES.AUTH);
    } else {
      if (userData === null) {
        fetchUserData(token);
      }
    }
  }, [token]);

  useEffect(() => {
    if (token === null) return;

    if (location.pathname === ROUTES.HOME) {
      navigate(ROUTES.PRODUCTS);
    }
  }, [location.pathname]);

  return (
    <div className={classes.root}>
      <Header />
      <Outlet />
      <Navigator />

      {isAppUpdated && <UpdatesModal updateVersion={updateVersion} />}
    </div>
  );
}
